import { mezoMatsnetTestnet } from "@mezo-org/passport"
import { useWaitForTransactionReceipt, useWriteContract } from "wagmi"

const useWriteContractAndWaitForTransaction = (
  chainId: number = mezoMatsnetTestnet.id,
) => {
  const { data: txHash, ...rest } = useWriteContract()

  const { isLoading: isWaitingForTxReceipt, isSuccess: isTxConfirmed } =
    useWaitForTransactionReceipt({
      hash: txHash,
      chainId,
    })

  return {
    ...rest,
    isWaitingForTxReceipt,
    isTxConfirmed,
    txHash,
  }
}

export default useWriteContractAndWaitForTransaction
